/*
 * @Author: chenyan
 * @Date: 2017-12-11 19:41:42
 * @Description:收单商户系统baseurl 配置
 * @Last Modified by: wanghf
 * @Last Modified time: 2025-10-15 14:39:57
 */
const env = process.env.NODE_ENV
console.log('环境变量', env)
function configUrlfunc(env) {
	switch (env) {
		case 'dev':
			return '/api'

		case 'development':
			return 'https://dev-acquirer-merchant.pingpongx.com'

		case 'test':
			return 'https://test-acquirer-merchant.pingpongx.com'

		case 'test-sg':
			return 'https://test-acquirer-merchant-sg.pingpongx.com'

		case 'sandbox':
			return 'https://sandbox-acquirer-merchant.pingpongx.com'

		case 'ro':
			return 'https://ro-acquirer-merchant.pingpongx.com'

			// case 'production':
			//   return 'https://acquirer-merchant.pingpongx.com'

		case 'production':
			return 'https://acquirer-merchant-fra.pingpongx.com'

		case 'pci':
			return 'https://acquirer-merchant.lejiapay.com'

		case 'production-us':
			return 'https://acquirer-merchant-us.pingpongx.com'
	}
}

export const configUrl = configUrlfunc(env)

// function dataDepUrlfunc(env) {
//   switch (env) {
//     case 'local':
//       return 'https://dev-logbury.pingpongx.com'
//       // return '/mock/acquirer'

//     case 'development':
//       return 'https://dev-logbury.pingpongx.com'

//     case 'test':
//       return 'https://test-logbury.pingpongx.com'

//     case 'sandbox':
//       return 'https://sandbox-logbury.pingpongx.com'

//     case 'ro':
//       return 'https://logbury.pingpongx.com'

//     // case 'production':
//     //   return 'https://logbury.pingpongx.com'

//     case 'production':
//       return 'https://logbury.pingpongx.com'

//     case 'pci':
//       return 'https://logbury.pingpongx.com'
//   }
// }

// export const dataDepUrl = dataDepUrlfunc(env)

// 官网host
function officialUrlfunc(env) {
	switch (env) {
		case 'local':
			return 'http://localhost:9002'

		case 'development':
			return 'https://dev-www.pingpongx.com'

		case 'test':
			return 'https://test-www.pingpongx.com'
		
		case 'test-sg':
			return 'https://test-www.pingpongx.com'

		case 'sandbox':
			return 'https://sandbox-www.pingpongx.com'

		case 'ro':
			return 'https://www.pingpongx.com'

			// case 'production':
			//   return 'https://www.pingpongx.com'

		case 'production':
			return 'https://www.pingpongx.com'

		case 'pci':
			return 'https://www.pingpongx.com'

		case 'production-us':
			return 'https://www.pingpongx.com'
	}
}

export const officialUrl = officialUrlfunc(env)

function getFsDomain(env) {
	switch (env) {
		case 'dev':
			return 'https://dev-acquirer-fs.pingpongx.com'

		case 'development':
			return 'https://dev-acquirer-fs.pingpongx.com'

		case 'test':
			return 'https://test-acquirer-fs.pingpongx.com'

		case 'test-sg':
			return 'https://test-acquirer-fs.pingpongx.com'

		case 'sandbox':
			return 'https://dev-acquirer-fs.pingpongx.com'

		case 'ro':
			return 'https://acquirer-fs-eu.pingpongx.com'

			// case 'production':
			//   return 'https://acquirer-fs-eu.pingpongx.com'

		case 'production':
			return 'https://acquirer-fs-fra.pingpongx.com'

		case 'pci':
			return 'acquirer-fs.lejiapay.com'

		case 'production-us':
			return 'https://acquirer-fs-us.pingpongx.com'
	}
}

export const fsDomain = getFsDomain(env)
